/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_RevokeInputs */

const vi_api_keys_revoke = /** @type {(inputs: Api_Keys_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu hồi`)
};

/**

* @param {Api_Keys_RevokeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_revoke = /** @type {((inputs?: Api_Keys_RevokeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_RevokeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_revoke(inputs)
});